import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { MissionPageContainer } from "../../common_components/Layout";
import ReviewUserTitleRow from "./ReviewUserTitleRow";
import ReviewUserApprovalCard from "./ReviewUserApprovalCard";
import SubHeader from "../SubHeader";
import ScreenerCard from "./ScreenerCard";
import AboutUserCard from "./AboutUserCard";






// Api Calls
import MissionUserListAPI from "../../../api/api_calls/MissionUserListsAPI";


function ReviewUserPage(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, appId } = useParams()

    const [application, setApplication] = useState({});
    const [firstName, setFirstName] = useState("");
    const [hasScreener, setHasScreener] = useState(false);
    const [loadingApp, setLoadingApp] = useState(true);


    useEffect(() => {
        async function getEventDetails() {
            const result = await MissionUserListAPI.show({ missionId, mission_user_list_id: appId, handleRedirect: navigate });

            if (result.success) {
                setApplication(result.mission_user_list)
                setFirstName(result.first_name)
                setHasScreener(result.has_screener)
                setLoadingApp(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getEventDetails();
    }, []);

    return (
        <>
            {loadingApp ? <CenteredLoadingIcon /> :
                <>
                    <SubHeader title={"Review User"} backText="Back to All Users" navigateBack={() => navigate("/missions/" + missionId + "/reviewusers/")} />
                    <MissionPageContainer>
                        <ReviewUserTitleRow mission_user_list={application} firstName={firstName} />
                        <ReviewUserApprovalCard session={props.session} />
                        {hasScreener ? <ScreenerCard mission_user_list_id={appId} /> : null}
                        <AboutUserCard mission_user_list_id={appId} />
                    </MissionPageContainer>
                </>
            }
        </>
    )
}


export default ReviewUserPage;